import React from 'react';

// Vyhledávací pole do popupů – input + křížek na smazání textu (jako v horní
// liště stránek). onChangeSearch dostává rovnou hodnotu, křížek posílá ''.
export default function PopupSearch({searchValue = '', onChangeSearch, placeholder = 'Vyhledat', className = '', maxLength = 100}) {
	return (
		<div className={`popup-search${className !== '' ? ` ${className}` : ''}`}>
			<input className="input-text popup-search__input" type="text" maxLength={maxLength} placeholder={placeholder} value={searchValue} onChange={(e) => onChangeSearch(e.target.value)} />
			{searchValue !== '' ? <button type="button" className="input-text-search-del popup-search__clear" onClick={() => onChangeSearch('')} aria-label="Smazat vyhledávání" /> : null}
		</div>
	);
}
